const allowedRoles = ["admin"];
export default [
  {
    path: "/admin/counties",
    component: () =>
      import(
        /* webpackChunkName: "counties" */ "@/views/admin/counties/ListCounties/ListCounties.vue"
      ),
    meta: {
      pageTitle: "Counties",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Counties"
      }
    }
  },
  {
    path: "/counties/activities/:countyId",
    component: () =>
      import(
        /* webpackChunkName: "counties" */ "@/views/admin/counties/CountiesActivities.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/counties",
          title: "Counties"
        }
      ],
      pageTitle: "Counties Activities",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Counties Activities"
      }
    }
  }
];
